import React, { useMemo, useState } from 'react';
import EcoSpace from 'eco-design/base/eco-space';
import EcoTitle from 'eco-design/base/eco-title';
import moment from 'moment';
import Countdown from './Countdown';
import style from './index.module.scss';
import { useLang } from '@/i18n';
import { useGlobal } from '@/utils/useGlobal';
import Dialog from './Dialog';
import gtm from '@/utils/gtm';

interface Props {
    endTime: number;
}

const EarlyBirdJP: React.FC<Props> = ({ endTime }) => {
    const { getSystemTime } = useGlobal();
    const systemTime = getSystemTime();
    const { t } = useLang('powerBank.EarlyBird');

    const fields = useMemo(() => {
        const date = moment(systemTime).format('DD.MM.YYYY');
        return [
            { type: 'single', id: '4431', value: 1, overwrite: true },
            { type: 'single', id: '31', value: 1, overwrite: false },
            { type: 'multiple', id: '12713', value: 3, overwrite: false },
            { type: 'text', id: '12712', value: date, overwrite: false },
        ];
    }, [systemTime]);

    const list = [
        {
            title: t('item1'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1748414114156/jp-1.png',
        },
        {
            title: t('item2'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1749534663650/jp-2.png',
        },
    ];

    // 弹窗
    const [open, setOpen] = useState(false);
    return (
        <>
            <EcoSpace />
            <div className={`${style.comp} GtmModuleData-section EarlyBirdJP`} id="EarlyBirdJP" data-section-id={'EarlyBirdJP'}>
                <EcoTitle title={t('title')} />
                <div className="countdown-box">
                    <div className="countdown-desc">{t('desc')}</div>
                    <Countdown targetTime={endTime} />
                </div>
                {/* <div className="email-hot-box">
                    <EcoEmail
                        contactListId={['503090051']}
                        source="WEB_NEW_PRODUCT_SUB"
                        fields={fields}
                        needTerms={false}
                        tipsObj={{
                            placeholder: t('emailPlaceholder'),
                        }}
                    />
                </div> */}
                <div className="cards">
                    {list.map((i, idx) => (
                        <div className="card-item" key={idx}>
                            <img src={i.pc} alt="" />
                            <div className="card-item-title">{i.title}</div>
                        </div>
                    ))}
                </div>
                <div
                    className="tc-btn GtmModuleData-btn-text"
                    onClick={() => {
                        setOpen(true);
                        gtm.push({
                            __btn_id1: 'EarlyBirdJP .tc-btn',
                            __btn_id2: t('footer'),
                            __btn_type: 'text',
                        });
                    }}
                >
                    {t('footer')}
                </div>
            </div>

            <Dialog open={open} onClose={() => setOpen(false)} />
        </>
    );
};
export default EarlyBirdJP;
